import { ProgressiveLoader } from '@/components'
import { AssessmentStepKeys } from '@/enums'
import { useSaveAssessmentStep } from '../helpers'

interface AssessmentLoadingStepProps {
  onNext: () => void
  stepsMessages: string[]
}

export const AssessmentLoadingStep = ({
  onNext,
  stepsMessages,
}: AssessmentLoadingStepProps) => {
  const { save } = useSaveAssessmentStep(AssessmentStepKeys.prepareData)

  const handleNext = () => {
    save()
    onNext()
  }

  return (
    <ProgressiveLoader
      totalDelay={2500}
      onComplete={handleNext}
      steps={stepsMessages}
    />
  )
}
